import { FormikState, FormikHandlers } from 'formik';
import React from 'react';

import { DateField } from '../date-field';

type Props = Omit<React.ComponentProps<typeof DateField>, 'name' | 'value' | 'onChange' | 'error' | 'helperText'> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikHandlers & FormikState<any>;
  name: string;
};

const FormikDateField: React.FC<Props> = (props: Props) => {
  const { name, formik, ...rest } = props;
  const meta = formik.getFieldMeta<string | null>(name);

  return (
    <DateField
      {...rest}
      name={name}
      value={meta.value}
      onChange={(value) => {
        const e = {
          target: { name, value },
        } as React.ChangeEvent<HTMLInputElement>;
        formik.handleChange(e);
      }}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
    />
  );
};

export { FormikDateField };
